import { createFileRoute } from '@tanstack/react-router'
import { ProfileHeader } from '@/components/preview/ProfileHeader'
import { ProfileInfo } from '@/components/preview/ProfileInfo'
import { PostGrid } from '@/components/preview/PostGrid'
import { useAtomValue } from 'jotai'
import { previewProfileAtom } from '@/atoms/previewProfile'
import { ConnectInstagramWarning } from '@/components/ConnectInstagramWarning'

export const Route = createFileRoute('/_app/')({
  component: Preview,
})

// TODO: Add suspense boundary
function Preview() {
  const profileData = useAtomValue(previewProfileAtom)

  if (!profileData.isConnected) {
    return <ConnectInstagramWarning description="Link Instagram to preview your posts" />
  }

  return (
    <div className="flex flex-col min-h-full w-full bg-white">
      <div className="flex flex-col gap-6 px-6 pt-6 md:px-0">
        <ProfileHeader title={`@${profileData.title}`} username={profileData.username} />
        <ProfileInfo
          avatar={profileData.avatar}
          name={profileData.name}
          description={profileData.description}
          stats={profileData.stats}
        />
      </div>
      <PostGrid />
    </div>
  )
}
